/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Open_2Inputs */

const en_pc_tut_open_2 = /** @type {(inputs: Pc_Tut_Open_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scroll through pages, or use the thumbnails and bookmarks panels to jump around.`)
};

const zh_pc_tut_open_2 = /** @type {(inputs: Pc_Tut_Open_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`滚动浏览页面，或使用缩略图和书签面板快速跳转。`)
};

/**
* | output |
* | --- |
* | "Scroll through pages, or use the thumbnails and bookmarks panels to jump around." |
*
* @param {Pc_Tut_Open_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_open_2 = /** @type {((inputs?: Pc_Tut_Open_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Open_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_open_2(inputs)
	return zh_pc_tut_open_2(inputs)
});
export { pc_tut_open_2 as "pc.tut.open.2" }